import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/trade-federation': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M202.4 108.4V190H38.9L87.2 251.9H201.9V448.7H266.5V253H349.8V190.3H266.6V171.1H412.2V108.4H202.4zM207.3 114.4H405.1V165.1H259.4V196H342.6V247H259.4V442.7H206.6V245.9H89.9L49.9 196H207.3V114.4zM248 8.8C111 8.8 0 119.8 0 256.8S111 504.8 248 504.8 496 393.8 496 256.8 385 8.8 248 8.8zM248 22C377.7 22 482.8 127.2 482.8 256.8S377.7 491.6 248 491.6 13.2 386.5 13.2 256.8 118.3 22 248 22zM248 29.9C122.7 29.9 21.1 131.5 21.1 256.8S122.7 483.7 248 483.7 474.9 382.1 474.9 256.8 373.3 29.9 248 29.9zM248 43.2C365.9 43.2 461.6 138.9 461.6 256.8S365.9 470.4 248 470.4 34.4 374.8 34.4 256.8 130 43.2 248 43.2zM174.7 148L190.3 166.1 168.2 156.6 155.8 177.1 158 153.1 134.7 147.7 158.2 142.3 156.1 118.5 168.5 139.2 190.5 129.9 174.7 148zM127.5 101.5L135.5 113.9 148.2 108 138.9 119.5 148.4 129.7 134.6 124.4 127.8 136.6 128.6 121.9 114.9 119.2 129.2 115.4 127.5 101.5zM378.3 177.1L390.3 196.6 411.2 187.5 396.3 205 411.4 222 390.2 213.2 378.6 232.9 380.4 210 358.2 205.1 380.5 199.7 378.3 177.1zM271.3 275.5L285.1 272.3 283.8 258.1 291.2 270.3 304.3 264.7 295 275.5 304.3 286.2 291.2 280.6 283.9 292.9 285.1 278.7 271.3 275.5zM145.8 282L169.6 278.2 167.8 253.6 178.8 275 201.6 265.8 184.7 282.9 200.5 301.7 179 290.9 166 311.7 169.7 288 145.8 282zM209.3 116.4V198H54.2L90.9 244H208.6V440.7H257.4V245H340.7V198H257.4V163.1H403.1V116.4H209.3zM220.1 127.6H391.9V151.9H246.9V208.2H329.8V232.1H246.9V429.5H220.1V232.1H96.3L76.2 208.2H220.1V127.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/trade-federation.js
// module id = 77Bc
// module chunks = 144